<template>
  <div class="p-3">
    <a-table
      class="table datatable thead-light"
      :columns="columns"
      :data-source="rows"
      :loading="loading"
      row-key="id"
      :row-selection="rowSelection"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'name'">
          <h6 class="fs-14 fw-medium">{{ record?.name || '—' }}</h6>
          <div class="text-muted small">
            Tag: {{ record?.asset_tag || '—' }} • Serial: {{ record?.serial_number || '—' }}
          </div>
        </template>

        <template v-else-if="column.key === 'category'">
          {{ record?.category?.name || '—' }}
        </template>

        <template v-else-if="column.key === 'assigned_to'">
          <div v-if="record?.assignee">
            {{ record.assignee.first_name }} {{ record.assignee.last_name }}
          </div>
          <div v-else>—</div>
        </template>

        <template v-else-if="column.key === 'purchase_date'">
          {{ record?.purchase_date || '—' }}
        </template>

        <template v-else-if="column.key === 'warranty_end_date'">
          {{ record?.warranty_end_date || '—' }}
        </template>

        <template v-else-if="column.key === 'status'">
          <span class="d-inline-flex align-items-center badge-xs"
                :class="['badge',
                  record?.status === 'Active' ? 'badge-success'
                  : record?.status === 'Maintenance' ? 'badge-warning'
                  : record?.status === 'Disposed' ? 'badge-secondary'
                  : 'badge-danger']">
            <i class="ti ti-point-filled me-1"></i>{{ record?.status }}
          </span>
        </template>

        <template v-else-if="column.key === 'action'">
          <div class="action-icon d-inline-flex">
            <a href="javascript:void(0);" class="me-2" @click="$emit('edit', record)"
              v-can="'Asset.Edit'">
              <i class="ti ti-edit"></i>
            </a>
            <a href="javascript:void(0);" @click="$emit('delete', record)"
              v-can="'Asset.Delete'">
              <i class="ti ti-trash"></i>
            </a>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(["edit", "delete", "bulk-delete"]);

const selectedRowKeys = ref([]);

const columns = [
  { title: "Asset", dataIndex: "name", key: "name" },
  { title: "Category", dataIndex: "category", key: "category" },
  { title: "Assigned To", dataIndex: "assigned_to", key: "assigned_to" },
  { title: "Purchase Date", dataIndex: "purchase_date", key: "purchase_date" },
  { title: "Warranty End", dataIndex: "warranty_end_date", key: "warranty_end_date" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "", dataIndex: "action", key: "action" },
];

const rowSelection = {
  selectedRowKeys: selectedRowKeys.value,
  onChange: (keys) => (selectedRowKeys.value = keys),
  onSelect: () => {},
  onSelectAll: () => {},
};

window.addEventListener("keydown", (e) => {
  if (e.key === "Delete" && selectedRowKeys.value.length) {
    emit("bulk-delete", selectedRowKeys.value);
  }
});
</script>
